module.exports = __webpack_public_path__ + "static/media/icon04.0d732650.svg";